<template>
  <div class="system-layout">
    <enfold>
      <div class="sl-body">
        <div class="sl-top flex-b-c">
          <div class="sl-top-left">
            <div class="sl-t-l-img">
              <el-upload class="avatar-uploader" :action="'/api'+uploadUrl" ref="company_background" :data="uploadParams" :show-file-list="false" accept="image/png" :auto-upload="false" :on-change="handleChange.bind(this, 'company_background')" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload.bind(this, 'company_background')">
                <img v-if="handleObj.company_background.imageUrl" :src="handleObj.company_background.imageUrl" class="avatar" />
                <i v-else class="el-icon-edit-outline avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="sl-t-l-btn">
              <p>{{$t('system.imageSize1')}}</p>
              <el-button round @click="uploadPictures('company_background')">{{$t('system.ReplacePicture')}}</el-button>
            </div>
          </div>
          <div class="sl-top-right">
            <div class="sl-t-r-item">
              <p class="logo">{{$t('system.LoginLogo')}}</p>
              <p class="layout">{{$t('system.imageSize2')}}</p>
              <div class="sl-t-r-img">
                <el-upload class="avatar-uploader" :action="'/api'+uploadUrl" :data="uploadParams" ref="company_loginLogo" :auto-upload="false" accept="image/png" :on-change="handleChange.bind(this, 'company_loginLogo')" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload.bind(this, 'company_loginLogo')">
                  <img v-if="handleObj.company_loginLogo.imageUrl" :src="handleObj.company_loginLogo.imageUrl" class="avatar" />
                  <i v-else class="el-icon-edit-outline avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-button round @click="uploadPictures('company_loginLogo')">{{$t('system.ReplacePicture')}}</el-button>
            </div>
            <div class="sl-t-r-item">
              <p class="logo">{{$t('system.SystemLogo')}}</p>
              <p class="layout">{{$t('system.imageSize2')}}</p>
              <div class="sl-t-r-img">
                <el-upload class="avatar-uploader" :action="'/api'+uploadUrl" ref="company_systemLogo" :auto-upload="false" accept="image/png" :on-change="handleChange.bind(this, 'company_systemLogo')" :data="uploadParams" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload.bind(this, 'company_systemLogo')">
                  <img v-if="handleObj.company_systemLogo.imageUrl" :src="handleObj.company_systemLogo.imageUrl" class="avatar" />
                  <i v-else class="el-icon-edit-outline avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-button round @click="uploadPictures('company_systemLogo')">{{$t('system.ReplacePicture')}}</el-button>
            </div>
            <div class="sl-t-r-item">
              <p class="logo">{{$t('css1')}}</p>
              <p class="layout">{{$t('css1')}}</p>
              <div class="sl-t-r-img-ico">
                <el-upload class="avatar-uploader" :action="'/api'+uploadUrl" ref="company_favicon" :auto-upload="false" accept=".ico" :on-change="handleChange.bind(this, 'company_favicon')" :data="uploadParams" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload.bind(this, 'company_favicon')">
                  <img v-if="handleObj.company_favicon.imageUrl" :src="handleObj.company_favicon.imageUrl" class="avatar" />
                  <i v-else class="el-icon-edit-outline avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <el-button round @click="uploadPictures('company_favicon')">{{$t('system.ReplacePicture')}}</el-button>
            </div>
          </div>
          <div class="sl-top-right-r">
            <system-set />
          </div>
        </div>
        <div class="sl-bottom">
          <div style="min-height:60px;">
            <p>{{$t('system.systemSettings')}}</p>
            <div class="flex-c">
              <el-checkbox v-model="configurationOne">{{$t('system.configInformation')}}</el-checkbox>
              <div class="referral-code">
                <span>{{$t('system.Mail')}}:</span>
                <el-input type="email" size="mini" v-model="referral.user" @change="verificationEmail" :placeholder="$t('system.PleaseInputEmail')"></el-input>
              </div>
              <div class="referral-code">
                <span>{{$t('system.DailyLimit')}}:</span>
                <el-input-number v-model="referral.limit" :min="1" :max="999" size="mini"></el-input-number>
              </div>
              <div class="referral-code">
                <el-button size="mini" type="primary" round @click="addReferralUser" :disabled="referral.user === ''">{{$t('system.AddUser')}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </enfold>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold';
import SystemSet from './children/SystemSet.vue';
import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";
const UPLOAD_URL = "/admin/access/updateLayoutImg";
export default {
  name: "SystemLayout",
  data() {
    return {
      configurationOne: false,
      uploadUrl: UPLOAD_URL,
      configurationTwo: true,
      uploadParams: {},
      handleObj: {
        company_background: {
          imageUrl: ''
        },
        company_loginLogo: {
          imageUrl: ''
        },
        company_systemLogo: {
          imageUrl: ''
        },
        company_favicon: {
          imageUrl: ''
        }
      },
      referral: {
        user: "",
        limit: 1
      }
    }
  },
  methods: {
    addReferralUser() {
      if (this.referral.user === "" || this.referral.limit <= 0) { return; }
      this.$http.post("/admin/signin/createReferralUser", this.referral, data => {
        console.log(data);
        this.$msg({ message: "推荐码用户注册成功!", type: "success", showClose: true });
      });
    },
    verificationEmail(email) {
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!reg.test(email)) {
        this.$msg({ message: "邮箱格式不正确!", type: "warning", showClose: true });
        // this.referral.user = "";
      }
    },
    uploadPictures(type) {
      switch (type) {
        case 'company_background':
          // this.uploadParams = handleDataAndSign(this.uploadUrl, {img_type: type});
          // this.uploadParams.id = 1111;
          break;
        case 'company_loginLogo':
          break;
        case 'company_systemLogo':
          break;
        case 'company_favicon':
          break;
      }
      // console.log(this.uploadParams);
      this.$refs[type].submit();
      // if (type === 'login') {
      //   console.log(type);
      // } else if (type === 'login-logo') {
      //   console.log(type);
      // } else if (type === 'system-logo') {
      //   console.log(type);
      // }
    },
    handleChange(type, file, fileList,) {
      console.log(file, fileList, type);
      switch (type) {
        case 'company_background':
          this.handleObj.company_background.imageUrl = URL.createObjectURL(file.raw);
          break;
        case 'company_loginLogo':
          this.handleObj.company_loginLogo.imageUrl = URL.createObjectURL(file.raw);
          break;
        case 'company_systemLogo':
          this.handleObj.company_systemLogo.imageUrl = URL.createObjectURL(file.raw);
          break;
        case 'company_favicon':
          this.handleObj.company_favicon.imageUrl = URL.createObjectURL(file.raw);
          break;
      }
    },
    handleAvatarSuccess(res) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      if (res.status === 1) {
        this.$msg({ message: res.tips, type: "success", showClose: true });
      } else {
        this.$msg({ message: res.tips, type: "warning", showClose: true });
      }
      this.$router.go(0);
    },
    beforeAvatarUpload(type, file) {
      // console.log(type);
      // const isJPG = file.type === 'image/png';
      // const imageTypes = ['image/png'];
      // console.log(file);
      // console.log(imageTypes.indexOf(file.type));
      // const allowUpload = imageTypes.indexOf(file.type) !== -1;
      const allowSize = file.size / 1024 / 1024 < 2;
      // if (!allowUpload) {
      //   this.$msg({ message: this.$t('system.UploadedType'), type: "warning", showClose: true });
      // }
      if (!allowSize) {
        this.$msg({ message: this.$t('system.UploadedSize'), type: "warning", showClose: true });
      }
      let params = handleDataAndSign(this.uploadUrl, { img_type: type });
      this.$set(this.uploadParams, 'token', params.token);
      this.$set(this.uploadParams, 'v', params.v);
      this.$set(this.uploadParams, 't', params.t);
      this.$set(this.uploadParams, 's', params.s);
      this.$set(this.uploadParams, 'img_type', params.img_type);
      // console.log(this.uploadParams);
      return allowSize;
    }
  },
  components: {
    enfold,
    SystemSet
  }
}
</script>

<style lang="scss" scoped>
.system-layout {
  width: 100%;
  height: 100%;
  .sl-body {
    width: 100%;
    height: 100%;
    .sl-top {
      width: 100%;
      height: 80%;
      // display: flex;
      overflow: hidden;
      .sl-top-left {
        width: 650px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .sl-t-l-img {
          width: 460px;
          height: 470px;
          /deep/ .avatar-uploader .el-upload {
            border: 1px dashed var(--theme-color-customized-1);
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }
          /deep/ .avatar-uploader .el-upload:hover {
            border-color: #409eff;
          }
          .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 460px;
            height: 470px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .avatar {
            width: 460px;
            height: 470px;
            display: block;
          }
        }
        .sl-t-l-btn {
          width: 120px;
          p {
            font-size: 16px;
            line-height: 24px;
            color: #617883;
            margin-bottom: 16px;
          }
        }
      }
      .sl-top-right {
        width: 300px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        .sl-t-r-item {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          width: 200px;
          p {
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 8px;
          }
          .logo {
            font-size: 18px;
            text-align: center;
            color: var(--theme-color-customized-1);
          }
          .layout {
            color: #617883;
          }
          .sl-t-r-img {
            width: 270px;
            height: 60px;
            margin-bottom: 8px;
            /deep/ .avatar-uploader .el-upload {
              border: 1px dashed var(--theme-color-customized-1);
              border-radius: 6px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
            }
            /deep/ .avatar-uploader .el-upload:hover {
              border-color: #409eff;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              width: 270px;
              height: 60px;
              line-height: 60px;
              text-align: center;
            }
            .avatar {
              width: 270px;
              height: 60px;
              display: block;
            }
          }
          .sl-t-r-img-ico {
            width: 60px;
            height: 60px;
            margin-bottom: 8px;
            /deep/ .avatar-uploader .el-upload {
              border: 1px dashed var(--theme-color-customized-1);
              border-radius: 6px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
            }
            /deep/ .avatar-uploader .el-upload:hover {
              border-color: #409eff;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              width: 60px;
              height: 60px;
              line-height: 60px;
              text-align: center;
            }
            .avatar {
              width: 60px;
              height: 60px;
              display: block;
            }
          }
        }
      }

      .sl-top-right-r {
        width: 400px;
        height: 100%;
      }
      .el-button {
        border-color: #4cccf0;
        /deep/ span {
          color: var(--theme-color-customized-1);
        }
      }
    }
    .sl-bottom {
      height: 20%;
      min-height: 100px;
      padding-left: 18px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        font-size: 18px;
        // padding: 18px 0px;
        padding-bottom: 18px;
      }
      .referral-code {
        display: flex;
        align-items: center;
        margin-left: 16px;
        font-size: 14px;
        color: #606266;
        span {
          white-space: nowrap;
          padding: 0px 10px;
        }
        /deep/.el-input__inner {
          border-radius: 14px;
        }
        /deep/.el-input-number__increase {
          border-radius: 0px 14px 14px 0px;
        }
        /deep/.el-input-number__decrease {
          border-radius: 14px 0px 0px 14px;
        }
      }
    }
  }
}
</style>
